module.exports = __webpack_public_path__ + "static/media/PhoneTick.1295099c.svg";